import React, { useEffect, useState } from "react";
import DateFilter from "./date";
import { addQueryLocalStorage, startLoader, stopLoader } from "../../../lib/utils";
import { getUserInfo, getUsersCount, getUsersCountV2, getUsersList, getUsersListV2 } from "../../../features/employees/helper/api";
import { isAuthenticated } from "../../../auth";
// import config from "../../../config";
import client from "../../../clients";
import _ from "lodash";

const EnquiryFilter = (props) => {

  const [currentElementId, setCurrentElementId] = useState("");
  const pageSize = 20;
  const [isLoaderStart,setLoaderStart] = useState(false);
  const [pageCount,setPageCount] = useState(0);
  const [total,setTotal] = useState(0);
  var [pageNo,setPageNo] = useState(0)
  const [trainersList, setTrainersList] = useState([]);
  const [selectedAttendant, setSelectedAttendant] = useState('');
  const [enquiryStatus, setEnquiryStatus] = useState("open");
  const [isGender, setGender] = useState("all");
  const {user,token} = isAuthenticated();
  const [source, setSource] = useState("");
  const sourceList = [
    "Google or other search", "Word of mouth", "Hoarding", "Article or Blog post", "Social Media", "Radio", "Television", "Justdial", "Leaflet", "Magazine/Newspaper", "Others"
  ];
  const [searchKey,setSearchKey] = useState('');

  const handleSelectedAttendant = trainer =>{
    setSelectedAttendant(trainer);
    addQueryLocalStorage("attendant",trainer._id);
  }

  const searchUser = event =>{
    setSearchKey(event.target.value);
  }


  const GetAllUserCount = async () =>{
    try{
      const params = {
        isAllUser:true,
        branchIDs:[props.selectedGym._id],
        roles:[5,6,7,10,2,3,1]
      }

      if(searchKey) params.q=searchKey;

      const response = await getUsersCountV2(user._id,token,params);
      if(!response.error){
        pageNo = 1;
        setPageNo(pageNo);
        setPageCount(Math.ceil(response.COUNT / pageSize));
        setTotal(response.COUNT);
      }
    }catch(error){

    }
  }



  const GetAllUsers = async (isReload) =>{
    try{
      const params = {
        pageNo,
        pageSize,
        isAllUser:true,
        branchIDs:[props.selectedGym._id],
        roles:[5,6,7,10,2,3,1]
      }

      if(searchKey) params.q=searchKey;

      const response = await getUsersListV2(user._id,token,params);
      if(!response.error){
        setTrainersList(isReload?response:[...trainersList,...response]);
      }
    }catch(error){

    }
  }

    const handleScroll = async event => {
      const {clientHeight, scrollTop, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight - 5)) && pageNo < pageCount && !isLoaderStart) {
        pageNo = pageNo + 1;
        setPageNo(pageNo)
        setLoaderStart(true)
        await GetAllUsers();
        setLoaderStart(false)
      }
    }

    const toggleEnquiryStatus = (value) => {
      setEnquiryStatus(value);
      addQueryLocalStorage("status",value);
    }

    const toggleGenderStatus = (value) => {
      setGender(value);
      addQueryLocalStorage("gender",value);
    }
    
    useEffect(async ()=>{
      try{
        await startLoader();
        await GetAllUserCount();
        await GetAllUsers(true);
      }catch(error){
  
      }
  
      await stopLoader();
      
    },[searchKey]);

  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
    }
  };



  const handleSource = (source) => {
    addQueryLocalStorage("source",source);
    setSource(source);
  }


  useEffect(async ()=>{
      try{
        const queryParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(queryParams.entries());
  
        if(params.attendant){
          let response = await getUserInfo(user._id,token,params.attendant);
          setSelectedAttendant(response);
        }else{
          setSelectedAttendant("");
        }

        if(params.gender){
          setGender(params.gender)
        }else{
          setGender("all")
        }
  
        if(params.source){
          setSource(params.source);
        }else{
          setSource("")
        }

        if(params?.status){
          setEnquiryStatus(params?.status || '')
        }

      }catch(error){
  
      }
    },[window.location.search]);

  return(
    <div className="w-full">
      <p className="fs-16 m-b-6 font-weight-700 color-black">Enquiry Filter</p>
      <div onClick={()=>toggleInputFields('attendant-list')} className={`${currentElementId == "attendant-list" || selectedAttendant ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "attendant-list" || selectedAttendant) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "attendant-list" || selectedAttendant) ? "4px" : ""}}>
          <svg className="flex-item m-r-4" width={(currentElementId == "attendant-list" || selectedAttendant) ? "14" : "24"} height={(currentElementId == "attendant-list" || selectedAttendant) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 4.07143C10.5439 4.07143 11.0756 4.22852 11.5278 4.52285C11.9801 4.81717 12.3325 5.23551 12.5407 5.72496C12.7488 6.2144 12.8033 6.75297 12.6972 7.27256C12.5911 7.79216 12.3291 8.26943 11.9445 8.64404C11.5599 9.01864 11.0699 9.27375 10.5365 9.3771C10.0031 9.48046 9.45012 9.42741 8.94762 9.22468C8.44512 9.02194 8.01563 8.67862 7.71346 8.23813C7.41128 7.79765 7.25 7.27977 7.25 6.75C7.25 6.0396 7.53973 5.35829 8.05546 4.85596C8.57118 4.35363 9.27065 4.07143 10 4.07143ZM10 3C9.23854 3 8.49418 3.21993 7.86105 3.63199C7.22793 4.04404 6.73446 4.62971 6.44306 5.31494C6.15167 6.00016 6.07542 6.75416 6.22398 7.48159C6.37253 8.20902 6.73921 8.8772 7.27764 9.40165C7.81607 9.9261 8.50208 10.2833 9.2489 10.4279C9.99573 10.5726 10.7698 10.4984 11.4733 10.2145C12.1768 9.93072 12.7781 9.45007 13.2012 8.83339C13.6242 8.2167 13.85 7.49168 13.85 6.75C13.85 5.75544 13.4444 4.80161 12.7224 4.09835C12.0003 3.39509 11.0211 3 10 3ZM15.5 18H14.4V15.3214C14.4 14.9697 14.3289 14.6214 14.1907 14.2964C14.0525 13.9714 13.8499 13.6761 13.5945 13.4274C13.3392 13.1787 13.036 12.9814 12.7024 12.8468C12.3687 12.7121 12.0111 12.6429 11.65 12.6429H8.35C7.62065 12.6429 6.92118 12.9251 6.40546 13.4274C5.88973 13.9297 5.6 14.611 5.6 15.3214V18H4.5V15.3214C4.5 14.3269 4.90562 13.373 5.62764 12.6698C6.34965 11.9665 7.32892 11.5714 8.35 11.5714H11.65C12.6711 11.5714 13.6503 11.9665 14.3724 12.6698C15.0944 13.373 15.5 14.3269 15.5 15.3214V18Z" fill={(currentElementId == "attendant-list" || selectedAttendant) ? "var(--darkBlue)" : "#6d6d6d"}/>
          </svg>
          <p className="placeholder-txt flex-item m-t-2" style={{ fontSize: (currentElementId == "attendant-list" || selectedAttendant) ? "10px" : "16px", lineHeight: (currentElementId == "attendant-list" || selectedAttendant) ? "10px" : "16px", color: (currentElementId == "attendant-list" || selectedAttendant) ? "var(--darkBlue)" : "", transition: "180ms" }}>Attendant</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "attendant-list" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        {
          selectedAttendant ? (
            <div className="w-full d-flex m-t-8 m-b-8">
              {/* <div className="enq-attendant-profile d-flex">
                <img className="flex-item w-full h-full margin-auto" src={'https://picsum.photos/id/4/200/300'} />
              </div> */}
              {
                selectedAttendant.profileID ? (
                   <div className="enq-attendant-profile d-flex">
                    <img className="flex-item w-full h-full margin-auto" src={`${client.config.API_URL}${client.config.prefixStream}/media/file/${selectedAttendant.profileID}?${Date.now()}`} />
                    </div>
                ):(
                 <div className="enq-attendant-profile d-flex" style={{backgroundColor: "#5d883c"}}>
                    <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${selectedAttendant.name}`.trim()[0]}</p>
                  </div>
                )
              }
              <div className="flex-item m-l-12">
                <p className="font-weight-600 fs-16" style={{lineHeight:"16px"}}>{selectedAttendant.name}</p>
              </div>
            </div>
          ) : <input id="attendant-list" className={`${(currentElementId == "attendant-list" || selectedAttendant) ? "active-input-field" : "inactive-input-field"} m-t-4`} type="text" placeholder="Select Trainer" value={selectedAttendant ? selectedAttendant : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        }
        
        {
          currentElementId == "attendant-list" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : selectedAttendant && "70px"}}>
              <div onClick={e => e.stopPropagation()} className="w-full" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0}}>
                <div className="search-container d-flex space-between" style={{width:"100%",background:"#ffffff"}}>
                  <div className="d-flex w-full">
                    <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <input onInput={_.debounce(searchUser,700)} type="text" placeholder={`Search Trainer by “Name“`} className="flex-item search-input" style={{width:"85%"}} />
                  </div>
                </div>
              </div>
              <div className="w-full" style={{padding:"0px 8px 8px 8px",minHeight:'100px',maxHeight:'150px',overflowY:'auto'}} onScroll={handleScroll}>
                {
                  trainersList.map((trainer, index) => {
                    return (
                      <div onClick={()=>handleSelectedAttendant(trainer)} className="global-input-field-arrow-dropdown-item d-flex">
                          {
                            trainer.profileID ? (
                                <img className="flex-item table-logo-icon m-r-8" src={`${client.config.API_URL}${client.config.prefixStream}/media/file/${trainer.profileID}?${Date.now()}`} />
                            ):(
                              <div className="table-logo-icon m-r-8 flex-item d-flex" style={{backgroundColor: "#5d883c"}}>
                                <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${trainer.name}`.trim()[0]}</p>
                              </div>
                            )
                          }
                          <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{trainer.name}</p>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
        }
      </div>
      <div onClick={()=>toggleInputFields('source')} className={`${currentElementId == "source" || source ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "source" || source) ? "1px solid var(--darkBlue)" : "" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "source" || source) ? "4px" : ""}}>
          {/* <svg className="flex-item m-r-4" width={(currentElementId == "source" || source) ? "14" : "24"} height={(currentElementId == "source" || source) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.4375 20.6635V12.3223L4.125 8.09501V16.0465C4.125 16.1626 4.15388 16.2711 4.21163 16.3722C4.26938 16.4733 4.35563 16.5594 4.47038 16.6305L11.4375 20.6635ZM12.5625 20.6635L19.5285 16.6305C19.644 16.5586 19.7306 16.4725 19.7884 16.3722C19.8461 16.2711 19.875 16.1626 19.875 16.0465V8.09501L12.5625 12.3223V20.6635ZM11.091 21.7563L3.909 17.6233C3.624 17.4608 3.40163 17.24 3.24188 16.9607C3.08063 16.6814 3 16.3793 3 16.0544V7.94677C3 7.62107 3.08063 7.31858 3.24188 7.03931C3.40238 6.76003 3.62475 6.53916 3.909 6.37669L11.091 2.24371C11.376 2.08124 11.679 2 12 2C12.321 2 12.624 2.08124 12.909 2.24371L20.091 6.37669C20.376 6.53841 20.5987 6.75929 20.7592 7.03931C20.9197 7.31858 21 7.62107 21 7.94677V16.0544C21 16.3793 20.9197 16.6814 20.7592 16.9607C20.598 17.24 20.3752 17.4608 20.091 17.6233L12.909 21.7563C12.624 21.9188 12.321 22 12 22C11.679 22 11.376 21.9188 11.091 21.7563ZM16.176 8.93958L19.2281 7.18643L12.3465 3.20957C12.231 3.13769 12.1155 3.10175 12 3.10175C11.8845 3.10175 11.769 3.13769 11.6535 3.20957L8.9625 4.75382L16.176 8.93958ZM12 11.3565L15.0375 9.59546L7.80937 5.42543L4.77187 7.18531L12 11.3565Z" fill={(currentElementId == "source" || source) ? "var(--darkBlue)" : "#6d6d6d"}/>
          </svg> */}
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "source" || source) ? "10px" : "16px", lineHeight: (currentElementId == "source" || source) ? "10px" : "14px", color: (currentElementId == "source" || source) ? "var(--darkBlue)" : "", transition: "180ms" }}>Source</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "source" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        <input id="source" className={`${(currentElementId == "source" || source) ? "active-input-field" : "inactive-input-field"} m-t-4`} type="text" placeholder="Select Source" value={source ? source : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        {
          currentElementId == "source" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", zIndex:100}}>
              <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                {
                  sourceList.map((source, index) => {
                    return (
                      <div onClick={()=>handleSource(source)} className="global-input-field-arrow-dropdown-item">
                        <p className="flex-item">{source}</p>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
        }
      </div>
      <p className="fs-16 m-b-6 font-weight-700 color-black">Gender</p>
      <div className="d-flex m-b-16">
        <div onClick={()=>toggleGenderStatus("all")} className="flex-item d-flex m-r-16">
          <input className="flex-item m-r-6" type="radio" name="gender" checked={isGender == "all" ? true : false} style={{width:"18px", height:"18px"}} />
          <p className="flex-item fs-16 font-weight-600" style={{color: isGender == "all" && "#055075"}}>All</p>
        </div>
        <div onClick={()=>toggleGenderStatus("Male")} className="flex-item d-flex m-r-16">
          <input className="flex-item m-r-6" type="radio" name="gender" checked={isGender == "Male" ? true : false} style={{width:"18px", height:"18px"}} />
          <p className="flex-item fs-16 font-weight-600" style={{color: isGender == "Male" && "#055075"}}>Male</p>
        </div>
        <div onClick={()=>toggleGenderStatus("Female")} className="flex-item d-flex m-r-16">
          <input className="flex-item m-r-6" type="radio" name="gender" checked={isGender == "Female" ? true : false} style={{width:"18px", height:"18px"}} />
          <p className="flex-item fs-16 font-weight-600" style={{color: isGender == "Female" && "#055075"}}>Female</p>
        </div>
        <div onClick={()=>toggleGenderStatus("Other")} className="flex-item d-flex">
          <input className="flex-item m-r-6" type="radio" name="gender" checked={isGender == "Other" ? true : false} style={{width:"18px", height:"18px"}} />
          <p className="flex-item fs-16 font-weight-600" style={{color: isGender == "Other" && "#055075"}}>Other</p>
        </div>
      </div>
      <DateFilter />
      <p className="fs-16 m-b-6 font-weight-700 color-black">Status</p>
      <div className="d-flex">
        <div onClick={()=>toggleEnquiryStatus("open")} className="flex-item d-flex m-r-16">
          <input className="flex-item m-r-6" type="radio" name="status" checked={enquiryStatus == "open" ? true : false} style={{width:"18px", height:"18px"}} />
          <p className="flex-item fs-16 font-weight-600" style={{color: enquiryStatus == "open" && "#055075"}}>Open</p>
        </div>
        <div onClick={()=>toggleEnquiryStatus("closed")} className="flex-item d-flex">
          <input className="flex-item m-r-6" type="radio" name="status" checked={enquiryStatus == "closed" ? true : false} style={{width:"18px", height:"18px"}} />
          <p className="flex-item fs-16 font-weight-600" style={{color: enquiryStatus == "closed" && "#055075"}}>Closed</p>
        </div>
      </div>
    </div>
  )
}

export default EnquiryFilter;